import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  allowedRole: 'empresa' | 'profissional';
}

export const RoleProtectedRoute = ({ children, allowedRole }: RoleProtectedRouteProps) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    // Mesmo tratamento do PrivateRoute — preserva a página de destino pra Login.tsx
    // redirecionar de volta pra cá depois do login.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.tipo !== allowedRole) {
    // Redireciona para a página apropriada baseada no tipo do usuário
    const redirectPath =
      user.tipo === 'admin' ? '/admin' :
      user.tipo === 'empresa' ? '/empresa/dashboard' : '/feed';
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};